export const venueTypes = [
  { value: 'coworking_space', label: 'Co-working Space' },
  { value: 'digital_nomad_hub', label: 'Digital Nomad Hub' },
  { value: 'ecovillage', label: 'Ecovillage' },
  { value: 'gym', label: 'Gym' },
  { value: 'herbal_apothecary', label: 'Herbal Apothecary' },
  { value: 'hot_yoga_studio', label: 'Hot Yoga Studio' },
  { value: 'massage_studio', label: 'Massage Studio' },
  { value: 'nutrition_clinic', label: 'Nutrition Clinic' },
  { value: 'offgrid_cabin', label: 'Off-grid Cabin' },
  { value: 'permaculture_farm', label: 'Permaculture Farm' },
  { value: 'retreat_center', label: 'Retreat Centre' },
  { value: 'wellness_spa', label: 'Wellness Spa' },
  { value: 'yoga_studio', label: 'Yoga Studio' },
  { value: 'yoga_teacher_training', label: 'Yoga Teacher Training' }
];